import { DEFAULTS, OBJECT, STRING, CONVERTERS } from "../constants/LocalStorageMap";

const LocalStorageService = {
  get: (key, asType = STRING) => {
    const value = localStorage.getItem(key);
    try {
      const nullish = [null, undefined].includes(value);
      return nullish ? DEFAULTS[asType] : CONVERTERS[asType](value);
    } catch (err) {
      return DEFAULTS[asType];
    }
  },
  set: (key, value) => {
    const converted =
      typeof value === OBJECT ? JSON.stringify(value) : value?.toString ? value.toString() : value;
    localStorage.setItem(key, converted);
  },
};

export default LocalStorageService;
